import React from 'react';
import './Controls.css';

const Controls = ({ isPlaying, onStart, onStop, vibeConfig, audioData }) => {
  return (
    <div className="controls">
      <div className="control-panel">
        <button 
          className={`control-btn ${isPlaying ? 'stop' : 'start'}`}
          onClick={isPlaying ? onStop : onStart}
        >
          {isPlaying ? 'Stop' : 'Start'} Audio
        </button>
        
        {/* Audio level indicators */}
        {audioData && (
          <div className="audio-levels">
            <div className="level-bar">
              <span>Bass</span>
              <div className="level-indicator">
                <div 
                  className="level-fill bass" 
                  style={{ width: `${Math.min(100, audioData.bass * 100)}%` }}
                />
              </div>
            </div>
            <div className="level-bar">
              <span>Mid</span>
              <div className="level-indicator">
                <div 
                  className="level-fill mid" 
                  style={{ width: `${Math.min(100, audioData.mid * 100)}%` }}
                />
              </div>
            </div>
            <div className="level-bar">
              <span>Treble</span>
              <div className="level-indicator">
                <div 
                  className="level-fill treble" 
                  style={{ width: `${Math.min(100, audioData.treble * 100)}%` }}
                />
              </div>
            </div>
          </div>
        )}
        
        {vibeConfig && (
          <div className="vibe-info">
            <h3>Current Vibe</h3>
            <div className="color-palette">
              {Object.entries(vibeConfig.colors || {}).map(([key, color]) => (
                <div 
                  key={key}
                  className="color-swatch"
                  style={{ backgroundColor: color }}
                  title={`${key}: ${color}`}
                />
              ))}
            </div>
            <div className="vibe-stats">
              <span>Complexity: {vibeConfig.geometry?.level || 1}</span>
              <span>Particles: {vibeConfig.geometry?.particleCount || 100}</span>
              <span>Type: {vibeConfig.geometry?.geometryType || 'sphere'}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Controls;